export default __webpack_public_path__ + "static/media/folder-close.78922f68.svg";